import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import IBlackListDevice from "@/interfaces/IBlackListDevice";
import ITableCol from "@/interfaces/ITableCol";
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";
import cleanData from "@/libs/cleanData";
import cloneObject from "@/libs/cloneObject";
import transformDateFields from "@/libs/date/transformDateFields";
import getParamQuery from "@/libs/getParamQuery";
import getQueryData from "@/libs/getQueryData";
import getTableColumns from "@/libs/getTableColumns";
import searchByTable from "@/libs/searchQuery/searchByTable";
import Multiselect from 'vue-multiselect';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import DefaultTools from '@/components/Includes/DefaultTools/DefaultTools.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import Pagination from '@/components/Includes/Pagination/Pagination.vue';
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import {Switch as cSwitch} from '@coreui/vue';

import BlackListDeviceCreate from '@/components/BlackListDevice/BlackListDeviceCreate/BlackListDeviceCreate.vue';
import BlackListDeviceDetail from '@/components/BlackListDevice/BlackListDeviceDetail/BlackListDeviceDetail.vue';

@Component({
    name: 'BlackListDevicesList',
    components: {
        DefaultTools,
        Loader,
        Pagination,
        BlackListDeviceCreate,
        BlackListDeviceDetail,
        TableEmpty,
        Multiselect,
        CardHeader,
        cSwitch
    }
})
export default class BlackListDevicesList extends Vue {

    // Begin Vuex Logic for Blacklist Device
    @Action private blackListDevicesList!: (query: IPayloadQuery) => Promise<void>;
    @Getter private getBlackListDevices!: () => IBlackListDevice[];
    @Action private blackListDeviceRemove!: (id: number) => string;
    // End Vuex Logic for Blacklist Device

    private loading: boolean = true;

    private createBlackListDeviceForm: boolean = false;
    private detailBlackListDeviceForm: boolean = false;

    private blackListDevices: IBlackListDevice[] = [];

    private selectedBlacklistDevice: IBlackListDevice | null = null;

    private filtered: any = null;

    private selectedTableColumns: IMultiSelectItem[] = [];

    // Begin Config for Pagination
    private totalBlackListDevices: number | void | null = null;
    private currentPage: number = 1;
    private selectedLimit: string = '100';
    // End Config for Pagination



    // Begin Config for Table
    private showModalDetail(blackListDevice: IBlackListDevice) {
        this.detailBlackListDeviceForm = !this.detailBlackListDeviceForm;
        this.selectedBlacklistDevice = cloneObject(blackListDevice);
    }

    private hideModalDetail() {
        this.detailBlackListDeviceForm = false;
        this.selectedBlacklistDevice = null;
    }

    private showModalCreate() {
        this.createBlackListDeviceForm = !this.createBlackListDeviceForm
    }

    private hideModalCreate() {
        this.createBlackListDeviceForm = false;
    }

    private filterData(query: string) { // Method for search tool
        this.filtered = searchByTable(query, this.blackListDevices)
    }

    private get tableItems(): IBlackListDevice[] {
        return this.filtered ? this.filtered : this.blackListDevices;
    }

    private get tableColumns(): ITableCol[] | undefined {
        if (this.tableItems) {
            return getTableColumns(this.blackListDevices, true, ['id'], {name: 'delete'});
        }
    };

    private get fields() {
        if (this.tableColumns) {
            const columnsIds = this.selectedTableColumns.map((el: IMultiSelectItem) => el.value);
            return this.tableColumns.filter((el: any) => columnsIds.includes(el.key));
        } else {
            return this.tableColumns;
        }
    }
    // End Config for Table

    private async deleteDevice(id: number) {
        try {
            const approveUpdate = confirm('Вы уверены что хотите обновить Device?');

            if (approveUpdate) {
                this.loading = true;
                const status = await this.blackListDeviceRemove(Number(id));

                if (status === 'deleted') {

                    await this.getBlacklistDevicesList();

                    this.$notify({
                        group: 'notice',
                        title: `Device`,
                        text: 'Deleted Successfully',
                        type: 'success'
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    // Begin Query Logic
    private get payloadQuery(): IPayloadQuery {
        return {
            ...getParamQuery(this.$route),
            metaData: true
        }
    }

    private queryValue() {
        if (this.payloadQuery.query && this.payloadQuery.query.length > 0) {
            this.readQueryValue();
        } else {
            this.writeQueryValue();
            this.readQueryValue();
        }
    }

    private readQueryValue() {
        const queryData = getQueryData(this.$route.query);

        queryData.map(({key, value}) => {
            switch (key) {
                case 'page': {
                    this.currentPage = value;
                    break;
                }
                case 'limit': {
                    this.selectedLimit = value;
                    break;
                }
                default:
                    break;
            }
        });
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private writeQueryValue() {
        const queryData: any = {
            page: this.currentPage,
            limit: this.selectedLimit
        };

        this.$router.replace({
            name: this.$route.name || undefined,
            query: cleanData(queryData)
        });
    }

    // End Query Logic

    // Begin Transform Data for Form Campaign
    private checkDateFields() {
        const dateFields: string[] = ['createdAt', 'updatedAt'];
        transformDateFields(dateFields, this.blackListDevices)
    }

    // End Transform Data for Form Campaign

    @Watch('selectedLimit')
    @Watch('currentPage')
    private async getBlacklistDevicesList() {
        try {
            this.loading = true;
            this.queryValue();

            this.totalBlackListDevices = await this.blackListDevicesList(this.payloadQuery);
            this.blackListDevices = this.getBlackListDevices();

            this.checkDateFields();

            this.loading = false;

        } catch (error) {
            throw new Error(error);
        }
    }

    private async mounted() {
        try {
            await this.getBlacklistDevicesList();
        } catch (error) {
            throw new Error(error);
        }
    }
}
